<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1">
    <b-col>
      <div class="center-form">
        <h2 class="text-center">Send email to club members</h2>
        <span class="failure">{{ failureMessage }}</span>
        <br>
        <b-form class="">
          <h4>Sending to</h4>
          <b-form-group id="info" label-for="info">
            <span>Club:</span> <b>{{ club.name }}</b>
            <br>
            <span>Members:</span> <b>{{ club.riders }}</b>
          </b-form-group>
          <h4>Email</h4>
          <b-form-group id="email" label-for="email">
            <span>Subject</span>
            <b-form-input 
              id="subject"
              v-model="form.subject.value" 
              :state="form.subject.error.state"
              placeholder="subject"
              readonly
              required
            />
            <b-form-invalid-feedback :state="form.subject.error.state">
              {{ form.subject.error.value }}
            </b-form-invalid-feedback>
            <br>
            <span>Body</span>
            <wysiwyg v-model="form.body.value" />
            <b-form-invalid-feedback :state="form.body.error.state">
              {{ form.body.error.value }}
            </b-form-invalid-feedback> 
          </b-form-group>
          <br>
          <c-button :onClick="onCancel" variant="secondary">Cancel</c-button>
          <c-button :onClick="onSend" variant="primary" class="right-align">Send</c-button>
          <br>
          <span class="success right-align">{{ formSuccess }}</span>
          <span class="failure right-align">{{ formFailure }}</span>
        </b-form>
      </div>
    </b-col>
  </b-row>
</template>

<script>

  import CButton from '@/components/Button'

  export default {
    name: 'SendEmail',
    components: { CButton },
    props: {
      id: String
    },
    data() {
      return {
        club: {},
        form: {
          subject: {
            value: '',
            error: {}
          },
          body: {
            value: '',
            error: {}
          },
        },
        formSuccess: '',
        formFailure: '',
        failureMessage: ''
      }
    },
    async created() {
      if (this.$router.currentRoute.meta.requiresAuth && (!this.$store.state.loggedUser || !this.$store.state.loggedUser.email)) this.$router.push({name: 'SignUp'})

      await this.getClub()
      await this.getEmailTemplate()
    },
    mounted() {

    },
    filters: {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      async getClub() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'public',
          query: require('@/graphql/getClub.graphql'),
          variables: {
            id: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getClub) {
          this.club = Object.assign({}, this.club, result.data.getClub)
        }
      },
      async getEmailTemplate() {
        this.failureMessage = ''

        const result = await this.$apollo.query({
          client: 'private',
          query: require('@/graphql/getEmailTemplate.graphql'),
          variables: {
            templateName: 'emailToClubMembers',
            clubId: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.failureMessage = e.body.message;
            }
          }
        }

        if (result && result.data && result.data.getEmailTemplate) {
          this.form.subject.value = result.data.getEmailTemplate.subject
          this.form.body.value = result.data.getEmailTemplate.html
        }
      },
      onCancel(event) {
        this.$router.push({ name: 'Club', params: { id: this.id } });
      },
      async onSend() {
        for (let key in this.form) {
          this.form[key].error = {}
        }
        this.formSuccess = ''
        this.formFailure = ''

        const result = await this.$apollo.mutate({
          client: 'private',
          mutation: require('@/graphql/sendEmail.graphql'),
          variables: {
            subject: this.form.subject.value,
            html: this.form.body.value,
            clubId: this.id
          }
        });

        if (result.errors) {
          const e = result;
          if (e.body) {
            if (e.body.message) {
              this.formFailure = e.body.message;
            }
            if (e.body.details) {
              e.body.details.map(detail => {
                detail.path.map(path => {
                  this.$set(this.form[path], 'error', {state: false, value: detail.message})
                })
              })
            }
          }
        } else {
          this.formSuccess = "Email sent";
          this.$router.push({ name: 'Club', params: { id: this.id }});
        }
      }
    }
  }
</script>

<style scoped>

</style>
